import { render, staticRenderFns } from "./MaterialStandardMappingLogList.vue?vue&type=template&id=6334de5f&scoped=true"
import script from "./MaterialStandardMappingLogList.vue?vue&type=script&lang=js"
export * from "./MaterialStandardMappingLogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6334de5f",
  null
  
)

export default component.exports